import { type ReactNode, useEffect } from "react";
import { I18nextProvider } from "react-i18next";

import i18n from "./config";
import { detectLocale } from "./use-locale";

/**
 * Applies the stored (or device) locale after mount.
 *
 * i18next is initialised synchronously with the default locale so the first render is
 * never blocked; the stored preference is applied in an effect.
 */
export function I18nProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    void (async () => {
      const target = await detectLocale();
      if (i18n.language !== target) await i18n.changeLanguage(target);
      document.documentElement.lang = target;
    })();
  }, []);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
